import React from 'react';
import PropTypes from 'prop-types';
import { Loader2 } from 'lucide-react';

const Spinner = ({
  size = 'md',
  color = 'primary',
  className = '',
  centered = false,
  fullScreen = false,
  label,
}) => {
  const sizes = {
    xs: 'w-4 h-4',
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16',
  };

  const colors = {
    primary: 'text-primary-600',
    secondary: 'text-secondary-600',
    success: 'text-success-600',
    warning: 'text-warning-600',
    danger: 'text-danger-600',
    neutral: 'text-neutral-600',
    white: 'text-white',
  };

  const spinnerClass = [
    'animate-spin',
    sizes[size] || sizes.md,
    colors[color] || colors.primary,
    className,
  ].filter(Boolean).join(' ');

  const spinner = (
    <div className="flex flex-col items-center gap-2">
      <Loader2 className={spinnerClass} />
      {label && (
        <span className="text-sm text-neutral-600 font-medium">
          {label}
        </span>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-50">
        {spinner}
      </div>
    );
  }

  if (centered) {
    return (
      <div className="flex items-center justify-center min-h-[200px]">
        {spinner}
      </div>
    );
  }

  return spinner;
};

Spinner.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  color: PropTypes.oneOf(['primary', 'secondary', 'success', 'warning', 'danger', 'neutral', 'white']),
  className: PropTypes.string,
  centered: PropTypes.bool,
  fullScreen: PropTypes.bool,
  label: PropTypes.string,
};

export default Spinner;
